const storages = {};

export function getLocalStorage() {
  return getStorage('localStorage');
}

export function getSessionStorage() {
  return getStorage('sessionStorage');
}

export function getStorage(storageType: string): any {
  try {
    return storages[storageType] || window[storageType];
  } catch {
    let storage = {};

    storages[storageType] = {
      clear: () => (storage = {}),
      getItem: (key: string) => storage[key] ?? null,
      removeItem: (key: string) => delete storage[key],
      setItem: (key: string, value: string) => {
        storage[key] = value?.toString();
      },
    };

    return storages[storageType];
  }
}
